"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdExtractor = void 0;
const ResourceLinkRegex_1 = __importDefault(require("./ResourceLinkRegex"));
class IdExtractor {
    static extract(value) {
        if (!value)
            return undefined;
        const matcher = RegExp(ResourceLinkRegex_1.default);
        if (!matcher.test(value))
            throw Error(`${value} isn't a resource URL`);
        return matcher.exec(value)?.[1];
    }
}
exports.IdExtractor = IdExtractor;
//# sourceMappingURL=IdExtractor.js.map